import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { SharedModule } from '../shared/shared.module';
import { CourseItemComponent } from './components/course-item/course-item.component';

@NgModule({
  declarations: [
    CourseItemComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    NgxChartsModule,
    RouterModule
  ],
  exports: [CourseItemComponent]
})
export class CourseSharedModule { }
